export default __webpack_public_path__ + "static/assets/86f568a0ecc0badac2c4952b39fff148.svg";